// extracted by mini-css-extract-plugin
module.exports = {"menuToggler":"AppStreamMenu_menuToggler__3KRiy","menuItem":"AppStreamMenu_menuItem__1ZX7c","title":"AppStreamMenu_title__2U8R2"};